import React from 'react';
import styled from 'styled-components';

const TableWrapper = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableHead = styled.thead`
//   background-color: #f2f2f2;
`;

const TableHeading = styled.th`
  padding: 12px;
  text-align: center;
  border: 1px solid #ddd;
  font-family: Roboto;
`;

const TableData = styled.td`
  padding: 12px;
  text-align: center;
  border: 1px solid #ddd;
  font-family: Roboto;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    // background-color: #f2f2f2;
  }
`;

function MySecondTable({ data }) {
  return (
    <TableWrapper>
      <TableHead>
        <tr>
          <TableHeading>Date</TableHeading>
          <TableHeading>Credit (Count)</TableHeading>
          <TableHeading>Credit (Mean)</TableHeading>
          <TableHeading>Credit (Sum)</TableHeading>
          <TableHeading>Debit (Count)</TableHeading>
          <TableHeading>Debit (Mean)</TableHeading>
          <TableHeading>Debit (Sum)</TableHeading>
        </tr>
      </TableHead>
      <tbody>
        {data.map(row => (
          <TableRow key={row.Date}>
            <TableData>{row.Date}</TableData>
            <TableData>{row['Credit (Count)']}</TableData>
            <TableData>{row['Credit (Mean)']}</TableData>
            <TableData>{row['Credit (Sum)']}</TableData>
            <TableData>{row['Debit (Count)']}</TableData>
            <TableData>{row['Debit (Mean)']}</TableData>
            <TableData>{row['Debit (Sum)']}</TableData>
          </TableRow>
        ))}
      </tbody>
    </TableWrapper>
  );
}


export default MySecondTable;

